import React, { Component, PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import LinkButton from 'components/LinkButton/LinkButton';
import AssistedBookingStatus from 'components/AssistedBookingStatus/AssistedBookingStatus';

import './AssistedBookingStatusModal.scss';

export default class AssistedBookingStatusModal extends Component {
  static propTypes = {
    bookingComponentStatuses: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapContains({
        status: PropTypes.string.isRequired,
        supplier: PropTypes.string.isRequired,
        component: PropTypes.string.isRequired,
        changed: PropTypes.bool.isRequired,
      }),
    ).isRequired,
    backUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
  };

  render() {
    const {
      bookingComponentStatuses,
      backUrl,
      onClose,
      onBack,
    } = this.props;

    return (
      <div className="assisted-booking-status-modal">
        <div className="assisted-booking-status-modal__title">
          Assisted Components
        </div>
        <AssistedBookingStatus bookingComponentStatuses={bookingComponentStatuses} />
        <div className="assisted-booking-status-modal__info">Please make sure you can source the assisted component(s) before continuing with the booking</div>
        <div className="assisted-booking-status-modal__navigation">
          <div className="assisted-booking-status-modal__navigation__back">
            <LinkButton
              color="blue"
              type="secondary"
              onClick={onBack}
              to={backUrl}
              isExternal
            >
              Back to search
            </LinkButton>
          </div>
          <div className="assisted-booking-status-modal__navigation__continue">
            <LinkButton onClick={onClose}>Continue</LinkButton>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AssistedBookingStatus/AssistedBookingStatusModal.jsx
 **/